import { NavigateNext, PlayCircle } from "@mui/icons-material";
import { Box } from "@mui/material";
import eSocial from "assets/brand-icons/12.png";
import alteracoes from "assets/brand-icons/alteracoes.png";
import buyerLTDA from "assets/brand-icons/buyer_ltda.png";
import massaTotal from "assets/brand-icons/massa_total.png";
import sellerLTDA from "assets/brand-icons/seller_ltda.png";
import eSovialLogo from "assets/esocial-logo.png";
import Chip from "components/table/table-chip";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "services/api";
import { useStyles } from "./styles";

export type IResult = {
  name: string;
  status: string;
  sellerId: ICustomer;
  buyerId: ICustomer;
  definitions: Definitions;
  executedAt: Date;
  isInactive: boolean;
};

export interface ICustomer {
  id: string;
  email: string;
  federalTaxId: string;
  telephone: string;
  corporateName: string;
}

export type Definitions = {
  connectors: Connector[];
  recipes: Connector[];
  tables: Table[];
};

export type Connector = {
  id: string;
  name: string;
  status: string;
  lasUpdate: string;
};

export type Table = {
  id: string;
  name: string;
  tables: string[];
};

interface IRouteParams {
  id: string;
}

const ProjectExecution: React.FC = () => {
  const [result, setResult] = useState<IResult | null>();
  const params = useParams<IRouteParams>();
  const classes = useStyles();

  const getChip = (text: string) => {
    if (text.includes("Em_Espera")) {
      return <Chip status={text.replaceAll("_", " ")} color="#BDBDBD" />;
    }

    if (text.includes("Pendente") || text.includes("Processando")) {
      return <Chip status={text.replaceAll("_", " ")} color="#EF6C00" />;
    }

    if (text.includes("Finalizado") || text.includes("Concedida")) {
      return <Chip status={text.replaceAll("_", " ")} color="#2E7D32" />;
    }
  };

  const handleExecuteRecipe = async (id: string) => {
    const dto = {
      project: "atualizacao_cadastral_sopeh",
      recipeId: id,
    };

    await api
      .post(`/project-executions/trigger`, dto)
      .then(async () => {
        await loadInitialData();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const loadInitialData = async () => {
    const { id } = params;

    await api
      .get(`/project-executions/${id}`)
      .then((response) => {
        const { data } = response.data;

        const definitions = JSON.parse(data.definitions);

        const projectExecutionResult: IResult = {
          name: data.name,
          status: data.status,
          buyerId: data.buyerId,
          sellerId: data.sellerId,
          definitions: {
            connectors: definitions.connectors,
            recipes: definitions.recipes,
            tables: definitions.tables,
          },
          executedAt: data.executedAt,
          isInactive: data.isInactive,
        };

        setResult(projectExecutionResult);
      })
      .catch((error) => {
        console.log(error);
        return error;
      });
  };

  useEffect(() => {
    if (params.id) {
      loadInitialData();
    }
  }, [params, params.id]);

  useEffect(() => {
    const timer = setInterval(() => {
      loadInitialData();
    }, 10000);

    return () => clearTimeout(timer);
  }, []);

  if (result === null || result === undefined) {
    return <Box>Carregando...</Box>;
  }

  return (
    <Box className={classes.root}>
      <Box className={classes.headerContainer}>
        <Box className={classes.headerText}>
          <h1>{result.name}</h1>
          <h5>
            Organização: <p>{result.buyerId?.corporateName}</p>
          </h5>
        </Box>

        <span
          className={`${true ? classes.statusActive : classes.statusInactive}`}
        >
          <p>{result.status}</p>
        </span>
      </Box>

      <Box className={classes.divider} />

      <table className={classes.baseContainer}>
        <thead>
          <tr>
            <th>
              <h1>Conectores</h1>
            </th>
          </tr>
        </thead>

        <tbody className={classes.itemContainer}>
          {result.definitions.connectors.map((connector) => (
            <tr key={Math.random()} className={classes.item}>
              <td className={classes.itemHeader}>
                <img
                  src={eSocial}
                  alt="e-social icon"
                  className={classes.startIcon}
                />
                <NavigateNext className={classes.arrow} />
                <img
                  src={eSovialLogo}
                  alt="e-social logo"
                  className={classes.logo}
                />
                <NavigateNext className={classes.arrow} />
                <span>{connector.name}</span>
              </td>

              <td className={classes.itemStatus}>
                {getChip(connector.status)}
              </td>

              <td className={classes.itemDate}>{connector.lasUpdate}</td>

              <td className={classes.itemFooter}></td>
            </tr>
          ))}
        </tbody>
      </table>

      <table className={classes.baseContainer}>
        <thead>
          <tr>
            <th>
              <h1>Workflow</h1>
            </th>
          </tr>
        </thead>

        <tbody className={classes.itemContainer}>
          {result.definitions.recipes.map((work, index) => {
            let buttonPlayStatusIsDisabled = false;

            const isInProcess = result.definitions.recipes.find(
              (recipe) => recipe.status == "Processando"
            );

            if (isInProcess != null && isInProcess != work) {
              buttonPlayStatusIsDisabled = true;
            }

            const previusRecipe = result.definitions.recipes[index - 1];

            if (previusRecipe != null && previusRecipe.status != "Finalizado") {
              buttonPlayStatusIsDisabled = true;
            }

            if (work.status == "Processando") {
              buttonPlayStatusIsDisabled = true;
            }

            return (
              <tr key={Math.random()} className={classes.item}>
                <td className={classes.itemHeader}>
                  <img
                    src={work.id == "alteracoes" ? alteracoes : massaTotal}
                    alt="start icon"
                    className={classes.startIcon}
                  />
                  <NavigateNext className={classes.arrow} />
                  <span>{work.name}</span>
                </td>

                <td className={classes.itemStatus}>{getChip(work.status)}</td>

                <td className={classes.itemDate}>
                  <span>{work.lasUpdate}</span>
                </td>

                <td className={classes.itemFooter}>
                  {buttonPlayStatusIsDisabled ? (
                    <PlayCircle className={classes.arrowPlayDisabled} />
                  ) : (
                    <PlayCircle
                      className={classes.arrowPlay}
                      onClick={() => handleExecuteRecipe(work.id)}
                    />
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <table className={classes.baseContainer}>
        <thead>
          <tr>
            <th>
              <h1>Tabelas</h1>
            </th>
          </tr>
        </thead>

        <tbody className={classes.itemContainer}>
          {result.definitions.tables.map((table) => {
            return (
              <tr key={Math.random()} className={classes.itemTable}>
                <td className={classes.itemHeader}>
                  <img
                    src={table.name == "SELLER_LTDA" ? sellerLTDA : buyerLTDA}
                    alt="start icon"
                    className={classes.startIcon}
                  />
                  <NavigateNext className={classes.arrow} />
                  <span>
                    {table.name == "SELLER_LTDA"
                      ? result.sellerId?.corporateName
                      : result.buyerId?.corporateName}
                  </span>
                </td>

                <td className={classes.tableContainer}>
                  {table.tables.map((t) => (
                    <section key={Math.random()}>
                      {t.replaceAll("_", " ")}
                      <br />
                    </section>
                  ))}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </Box>
  );
};

export default ProjectExecution;
